export default "__VITE_ASSET__B$8yQmIz__"